import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthCallback, ProtectedRoute } from "./components/AuthComponents";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Dashboard from "./pages/Dashboard";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DiscoverPage from "./pages/DiscoverPage";
import StartupDetail from "./pages/StartupDetail";
import DealRoomsPage from "./pages/DealRoomsPage";
import DealRoomDetail from "./pages/DealRoomDetail";
import InvestorsPage from "./pages/InvestorsPage";
import VCFundsPage from "./pages/VCFundsPage";
import WatchlistPage from "./pages/WatchlistPage";
import ThesesPage from "./pages/ThesesPage";
import OutreachPage from "./pages/OutreachPage";
import SettingsPage from "./pages/SettingsPage";
import OpsPage from "./pages/OpsPage";
import StealthPage from "./pages/StealthPage";

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/discover" element={<ProtectedRoute><DiscoverPage /></ProtectedRoute>} />
      <Route path="/startups/:id" element={<ProtectedRoute><StartupDetail /></ProtectedRoute>} />
      <Route path="/deal-rooms" element={<ProtectedRoute><DealRoomsPage /></ProtectedRoute>} />
      <Route path="/deal-rooms/:id" element={<ProtectedRoute><DealRoomDetail /></ProtectedRoute>} />
      <Route path="/investors" element={<ProtectedRoute><InvestorsPage /></ProtectedRoute>} />
      <Route path="/vc-funds" element={<ProtectedRoute><VCFundsPage /></ProtectedRoute>} />
      <Route path="/watchlist" element={<ProtectedRoute><WatchlistPage /></ProtectedRoute>} />
      <Route path="/theses" element={<ProtectedRoute><ThesesPage /></ProtectedRoute>} />
      <Route path="/outreach" element={<ProtectedRoute><OutreachPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/ops" element={<ProtectedRoute><OpsPage /></ProtectedRoute>} />
      <Route path="/stealth" element={<ProtectedRoute><StealthPage /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
